import React from 'react';
import { SparklesIcon } from '@heroicons/react/24/outline';

/**
 * Indicateur d'attente : trois points animés dans une bulle « assistant ».
 * `libelle` permet de réutiliser le composant avec un autre texte d'attente.
 */
const IndicateurSaisie = ({ libelle = 'L’assistant analyse les commandes…' }) => (
  <div className="flex gap-3">
    <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary-600 text-white" aria-hidden="true">
      <SparklesIcon className="h-4 w-4" />
    </div>
    <div className="inline-flex items-center gap-2 rounded-2xl rounded-tl-sm border border-gray-200 bg-gray-50 px-4 py-3">
      <span className="flex gap-1" aria-hidden="true">
        <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-gray-400 [animation-delay:-0.3s]" />
        <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-gray-400 [animation-delay:-0.15s]" />
        <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-gray-400" />
      </span>
      <span className="text-xs text-gray-500">{libelle}</span>
    </div>
  </div>
);

export default IndicateurSaisie;
